export default {
  en: {
    TeamPasswordScene: {
      title: 'Change password',
    },
  },
};
